import Swiper, { Autoplay, Grid, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

if (document.getElementsByClassName('markets-section__slider')[0]) {
  const marketsSlidersArr = document.querySelectorAll(
    '.markets-section__slider'
  );
  marketsSlidersArr.forEach((sliderEl, sliderIdx) => {
    const slides = sliderEl.querySelectorAll('.swiper-slide');
    /*let loop = false;
    let loopedSlides = false;*/

    /*if (slides.length >= 4) {
      loop = true;
      loopedSlides = slides.length * 4;
    }*/

    let marketsSwiper;

    function initSwiper() {
      marketsSwiper = new Swiper(sliderEl, {
        modules: [Autoplay, Navigation, Grid],
        slidesPerView: 1,
        spaceBetween: 20,
        threshold: 10,
        grid: {
          rows: 3,
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          prevEl: sliderEl.querySelector('.slider-buttons .slider-btn.prev'),
          nextEl: sliderEl.querySelector('.slider-buttons .slider-btn.next'),
        },
        breakpoints: {
          591: {
            slidesPerView: 2,
          },
        },
      });

      /*if (!sliderEl.classList.contains('init-observer')) {
        sliderEl.classList.add('init-observer');
        swiperObserver(foundationsSwiper);
      }*/
    }

    function handleResize() {
      if (window.innerWidth <= 1020) {
        initSwiper();
      } else {
        if (marketsSwiper) {
          marketsSwiper.destroy();
        }
      }
    }

    initSwiper();
    handleResize();

    window.addEventListener('resize', handleResize);
  });
}
